module.exports = __webpack_public_path__ + "img/vegetable-shallots-350x184.9ae1797c.jpg";